import { SubTableFrame, Table } from "../Components/Table"
import { HitAngleChart } from "./Chart/HitAngleChart"
import { HitBarrelChart } from "./Chart/HitBarrelChart"
import { ChartPr } from "./Chart/ChartPr"
import { ChartZone, ZoneChart } from "./Chart/ZoneChart"
import { useEffect, useState } from "react"
import { sortByTag } from "../Utils/Sort"


const ColSubTableFrame = ({ col = 'col3', title, content }) => {
  return (
    <div className={col}>
      <SubTableFrame title={title} tables={content} />
    </div>
  )
}


// export const getColorPR = (val)=>{
//   if(val >=0 && val <=10){
//     return "#5E81BD"
//   }else if(val >=11 && val <=20){
//     return "#86A0CE"
//   }else if(val >=21 && val <=30){
//     return "#AFC0DE"
//   }else if(val >=31 && val <=40){
//     return "#D7DFEF"
//   }else if(val >=41 && val <=50){
//     return "#FFFFFF"
//   }else if(val >=51 && val <=60){
//     return "#F7D3D4"
//   }else if(val >=61 && val <=70){
//     return "#EFA6A9"
//   }else if(val >=71 && val <=80){
//     return "#E87A7F"
//   }else if(val >=81 && val <=90){
//     return "#E04D54"
//   }else if(val >=91 && val <=100){
//     return "#D82129"
//   }
// }

export const PersonalBatterTable = ({ data, teststatPR, anglePR, volePR }) => {
  const [angleZone, setAngleZone] = useState(data.angleZone)
  const [voleZone, setVoleZone] = useState(data.veloZone)
  let overallTable = [
    <Table tableName='overallOne' data={[data.overall[0]]} />,
    <Table tableName='overallTwo' data={[data.overall[1]]} />
  ]
  var Ozone = ['Ozone1', 'Ozone2', 'Ozone3', 'Ozone4']
  var Zone = ['Zone1', 'Zone2', 'Zone3', 'Zone4', 'Zone5', 'Zone6', 'Zone7', 'Zone8', 'Zone9']

  useEffect(() => {
    // console.log(data)
    // console.log(data.hit)
    var angle = JSON.parse(JSON.stringify(data.angleZone))
    var velo = JSON.parse(JSON.stringify(data.veloZone))

    // console.log(angle)
    // console.log(velo)

    var angleAll = JSON.parse(JSON.stringify(anglePR))
    var voleAll = JSON.parse(JSON.stringify(volePR))

    Ozone.forEach((z, i) => {
      // console.log(angleZone.ozone[i])
      if (angle.ozone[i] > 0) {
        // console.log(i + " " + z + " " + angle.ozone[i])
        // console.log(angle.ozone)
        angleAll[z].push({ player: teststatPR[0].Player, val: Math.abs(angle.ozone[i] - 20).toString(), rank: 0 })
        var rank = sort(angleAll[z], false).find(a => a.player === teststatPR[0].Player).rank
        angle.ozonePR[i] = (((angleAll[z].length - rank) / (angleAll[z].length - 1) ) * 100)-1
      }

      if (velo.ozone[i] > 0) {
        // console.log(i + " " + z + " " + velo.ozone[i])
        // console.log(velo.ozone)
        voleAll[z].push({ player: teststatPR[0].Player, val: velo.ozone[i], rank: 0 })
        var rank = sort(voleAll[z], true).find(a => a.player === teststatPR[0].Player).rank
        velo.ozonePR[i] = (((voleAll[z].length - rank) / (voleAll[z].length - 1) ) * 100)-1
      }
    })
    // console.log(angle.ozonePR)
    // console.log(angleAll)
    // console.log(voleAll)

    Zone.forEach((z, i) => {

      if (angle.zone[i] > 0) {
        // console.log(i + " " + z + " " + angle.zone[i])
        // console.log(angle.zone)
        angleAll[z].push({ player: teststatPR[0].Player, val: Math.abs(angle.zone[i]-20), rank: 0 })
        var rank = sort(angleAll[z], false).find(a => a.player === teststatPR[0].Player).rank
        angle.zonePR[i] = (((angleAll[z].length - rank) / (angleAll[z].length - 1) ) * 100)-1
      }

      if (velo.zone[i] > 0) {
        // console.log(i + " " + z + " " + velo.zone[i])
        // console.log(velo.zone)
        voleAll[z].push({ player: teststatPR[0].Player, val: velo.zone[i], rank: 0 })
        var rank = sort(voleAll[z], true).find(a => a.player === teststatPR[0].Player).rank
        velo.zonePR[i] = (((voleAll[z].length - rank) / (voleAll[z].length - 1) ) * 100)-1
      }
    })

    // console.log(angle)
    // console.log(velo)
    setAngleZone(angle)
    setVoleZone(velo)
  }, [data])

  // console.log(teststatPR)

  function sort(all, reverse) {

    let sortedForPR = sortByTag(all, 'val', reverse)
    // console.log(sortedForPR)
    var rank = sortedForPR.length
    var tmp
    sortedForPR.forEach((pr, i) => {
      if (tmp != null && tmp.val !== null) {
        // console.log(tmp.val + " : " + pr.val)
        if (tmp.val !== pr.val) {
          pr.rank = rank
        } else {
          // console.log('相同')
          pr.rank = tmp.rank
        }
      } else {
        pr.rank = rank
      }
      tmp = pr
      rank--
    })
    sortedForPR = sortByTag(sortedForPR, 'rank', true)
    // console.log(sortedForPR)
    return sortedForPR
  }

  //console.log(data.hit)

  return (
    <div className="page_content tab_table">
      <SubTableFrame title='總覽' tables={overallTable} />
      <ColSubTableFrame title='指標數據PR' content={<ChartPr teststatPR={teststatPR} />} />
      <ColSubTableFrame title='Zone - 仰角' content={<ZoneChart title={'Avg Launch Angle'}  zone={angleZone} />} />
      <ColSubTableFrame title='Zone - 初速' content={<ZoneChart title={'Avg Exit Velocity'} zone={voleZone} />} />
      <ColSubTableFrame title='擊球結果圖' content={<HitBarrelChart pData={data.hit} />} />
      <ColSubTableFrame col='col3_2' title='逐球擊球初速 / 擊球仰角' content={<HitAngleChart velo={data.exit.velo} angle={data.exit.angle} />} />
    </div>
  )
}